import { useIntl } from 'react-intl';
import React, { FC, ReactNode } from 'react';
import { LanguageProvider } from '@cld/intl';
import { ButtonLink } from '@cld/button';
import EmptyState, { CommonEmptyStateProps } from '../../EmptyState';
import { loadMessages, messages } from '../../i18n';
import notFound from './notFound.svg';

export interface NotFoundProps extends CommonEmptyStateProps {
  /** Action button text */
  action?: ReactNode;
  /** Action button onClick handler */
  onActionClick?(): void;
  /** Temporary TS fix */
  actionText?: Record<string, string>;
}

export const NotFound: FC<React.PropsWithChildren<NotFoundProps>> = ({ action, onActionClick, ...rest }) => {
  const { formatMessage } = useIntl();
  return (
    <EmptyState imageSrc={notFound} imageHeight={145} imageWidth={138} title={formatMessage(messages.notFoundTitle)} {...rest}>
      {action && <ButtonLink onClick={onActionClick}>{action}</ButtonLink>}
    </EmptyState>
  );
};

const NotFoundIntl: FC<React.PropsWithChildren<NotFoundProps>> = (props) => (
  <LanguageProvider loadMessages={loadMessages}>
    <NotFound {...props} data-test-specifier="app-error" />
  </LanguageProvider>
);

export default NotFoundIntl;
